import React from 'react';

import { Block } from './Block.jsx';
import { Builder, EditorContainer, EmptyPlaceholder } from '../layout/Builder.jsx';
import { default as _Image, ImageSrcSet, withTupleGeneration } from './Image.jsx';
import Layout from './Layout.jsx';
import Name from './Name.jsx';
import Token from './Token.jsx';
import Utilities from './Utilities.jsx';

function ContainerComponent(props) {
    const contentConfig = props.contentConfig || {};
    let blocks = [];
    if (contentConfig.desktop && contentConfig.desktop.blocks) {
        blocks = contentConfig.desktop && contentConfig.desktop.blocks;
    }
    let className = `cell--whitelabel cell--whitelabel--${props.type}`;
    if (props.className) {
        className += ` ${props.className}`;
    }
    const containerProps = contentConfig.desktop && contentConfig.desktop.page;
    let pageProps;
    if (props.onPageProps) {
        pageProps = props.onPageProps();
    } else {
        pageProps = containerProps;
    }
    let containerStyle = {};
    if (pageProps && pageProps.config && pageProps.config.block && pageProps.config.block.borderRadius && pageProps.config.block.borderRadius.value) {
        containerStyle.overflow = 'hidden';
    }
    const columnSpacing = Layout.columnSpacing(props.index, props.columnCount, props.columnSpacing);
    if (columnSpacing) {
        containerStyle.marginLeft = columnSpacing.left;
        containerStyle.marginRight = columnSpacing.right;
    }
    const styleSpacer = { marginBottom: '20px' };
    if (props.listData && props.lineSpacing) {
        if (Layout.shouldUseLineSpacing(props.index, props.listData.length, props.columnCount)) {
            containerStyle.marginBottom = props.lineSpacing;
        }
        styleSpacer.marginBottom = props.lineSpacing;
    }
    let handleBuilderBlockProps;
    if (props.builder) {
        handleBuilderBlockProps = (d, blockConfig, parentProps) => {
            let blockProps = Builder.handleBlockProps(d, blockConfig, parentProps);
            if (props.builderBlockPropsHandler) {
                Utilities.copyObject(props.builderBlockPropsHandler(d, blockConfig, parentProps), blockProps);
            }
            Utilities.copyObject(Builder.handleCellBlockProps(d, blockConfig, parentProps), blockProps);
            return blockProps;
        }
        if (!props.editor) {
            containerStyle.pointerEvents = 'none';
        }
    }
    const handleContent = (content, style, contentProps) => {
        // contentProps.backgroundColor = props.onBackgroundColor && props.onBackgroundColor();
        let _content = <>{props.children}{content}</>
        if (props.editor) {
            const contentClassName = contentProps.className;
            contentProps.className = undefined;
            return <div className={contentClassName} style={style}>{_content}</div>
        } else if (props.onContent) {
            _content = props.onContent(_content, style, contentProps);
        }
        Utilities.copyObject(style, contentProps.style);
        _content = (
            <React.Fragment>
                {_content}
                {
                    props.useCellSpacer != false &&
                    <div className="cell--spacer" style={styleSpacer} />
                }
            </React.Fragment>
        )
        if (props.link && contentProps.style) {
            contentProps.style.display = 'block';
        }
        return _content;
    }
    return (
        <EditorContainer
            {...props}
            blocks={blocks}
            builderBlockPropsHandler={handleBuilderBlockProps}
            className={className}
            containerProps={containerProps}
            inCell={true}
            style={containerStyle}
            onContainerProps={props.onPageProps}
            onContent={handleContent} />
    );
}
function Container(props) {
    const handleBuilderBlockProps = (d, blockConfig, parentProps) => {
        const blockProps = Builder.handleBlockProps(d, blockConfig, parentProps) || {};
        if (!d.type) {
            return blockProps;
        }
        if (props.builderBlockPropsHandler) {
            Utilities.copyObject(props.builderBlockPropsHandler(d, blockConfig, parentProps), blockProps);
        }
        switch (d.type.value) {
            case Name.Block.Artist.Cell.Image:
            case Name.Block.Blog.Cell.Image:
            case Name.Block.Inventory.Cell.Image:
            case Name.Block.SearchResult.Cell.Image.Artist:
            case Name.Block.SearchResult.Cell.Image.Blog:
            case Name.Block.SearchResult.Cell.Image.Inventory:
            case Name.Block.SearchResult.Cell.Image.Show:
            case Name.Block.Show.Cell.Image:
                if (parentProps.inLayout && blockConfig && blockConfig.layout) {
                    if (!blockProps.style) {
                        blockProps.style = {};
                    }
                    blockProps.style.alignItems = 'inherit';
                }
                break;
            case Name.Block.Columns:
                blockProps.builderBlockPropsHandler = handleBuilderBlockProps;
                break;
        }
        return blockProps;
    }
    return <ContainerComponent {...props} builderBlockPropsHandler={handleBuilderBlockProps}>{props.children}</ContainerComponent>
}

// region IMAGE

function _ImageComponent(props) {
    const { contentStyle, imageStyle, style } = _Image.cellStyles(props);
    let image;
    if (props.imageTuples) {
        image = (
            <ImageSrcSet
                className={props.className}
                builder={props.builder}
                config={props.config}
                data={props.imageData}
                imageId={props.imageId}
                imageTuples={props.imageTuples}
                style={imageStyle} />
        );
    }
    if (!props.builder && props.hoverEffectVisible) {
        image = <span style={props.hoverStyle} onMouseEnter={props.onHoverStart} onMouseLeave={props.onHoverEnd}>{image}{props.hoverEffect}</span>
        style.overflow = 'visible';
    }
    let content = (
        <div style={contentStyle}>
            {image}
            {
                props.editor &&
                !props.imageTuples &&
                <EmptyPlaceholder />
            }
        </div>
    );
    if (props.link) {
        return <a href={props.link} style={style}>{content}</a>
    }
    return <div style={style}>{content}</div>
}
const _ImageIntermediate = withTupleGeneration(_ImageComponent);
function Image(props) {
    const handleBlockProps = (style, propName, propValue, propUnit) => {
        if (props.blockPropsHandler && props.blockPropsHandler(style, propName, propValue, propUnit)) {
            return true;
        }
        switch (propName) {
            case 'maxHeight':
                if (props.builder && props.inLayout && propValue) {
                    style.maxHeight = `${propValue}${propUnit}`;
                    style.minWidth = 'auto';
                }
                return props.builder;
            case 'width':
                if (props.builder && props.inLayout && propValue) {
                    style.alignSelf = 'inherit';
                    style.maxWidth = '100%';
                }
                return false;
        }
    }
    return (
        <_ImageIntermediate {...props} blockPropsHandler={handleBlockProps}>
            {props.children}
        </_ImageIntermediate>
    )
}

// #region META

function _Meta(props) {
    let style = {};
    if (props.blockConfig) {
        if (props.blockConfig.layout) {
            Block.mapStyleConfigProps(style, props.blockConfig.layout, (propName) => {
                switch (propName) {
                    case 'minWidth':
                        return props.inLayout != true;
                }
            });
        }
        if (props.blockConfig.container) {
            Block.mapStyleConfigProps(style, props.blockConfig.container, (propName, propValue) => {
                switch (propName) {
                    case 'animation':
                        return true;
                }
            });
        }
    }
    if (style.maxHeight) {
        style.overflow = 'hidden';
    }
    if (style.maxWidth) {
        style.width = '100%';
    }
    if (props.builder) {
        if (style.maxWidth) {
            style.maxWidth = undefined;
        }
        if (style.minWidth && style.minWidth.indexOf('%') > 0) {
            style.minWidth = undefined;
            style.width = '100%';
        }
    }
    return (
        <div style={style}>
            {
                props.content != undefined &&
                <div className="cont--token" dangerouslySetInnerHTML={{ __html: props.content }} style={{ lineHeight: 1 }} />
            }
            {
                props.builder &&
                (props.content == undefined || props.content.length == 0) &&
                <EmptyPlaceholder />
            }
        </div>
    );
}
const Meta = Token.withContentTokenParsing(
    _Meta,
    { extraParseConditionHandler: (props) => props.parseConditions || [] },
    (props, keyword, options) => props.onTokenReplacement ? props.onTokenReplacement(keyword, options) : ''
);

// #endregion META

export {
    Container,
    Image,
    Meta
}
